import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import { convertFromRaw } from "draft-js";
import InnerHeader from "../common/InnerHeader";
import Footer from "../common/Footer";
import "../homepage/Style/testimonial.css";

const TestimonialsList = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios.get(`${config.baseUrl}/testimonial/list`).then(res => {
      setTestimonials(res.data.data || []);
    });
  }, []);

  const renderText = (json) => {
    try {
      const raw = JSON.parse(json);
      return convertFromRaw(raw).getPlainText();
    } catch {
      return json;
    }
  };

  return (
    <>
      <InnerHeader />

      <div className="reviewPage">
        <div className="container">

          <div className="reviewTabs">
            <button className="btn btn-orange">READ REVIEWS</button>
            <a href="/write-review" className="btn btn-light">WRITE A REVIEW</a>
          </div>

          <div className="testimonialList">
            {testimonials.map((item, i) => (
              <div key={i} className="testimonialItem">
                <h5>
                  {item.name}
                  <span>{item.country}</span>
                </h5>
                <div className="stars">
                  {"★".repeat(item.rating)}
                  {"☆".repeat(5 - item.rating)}
                </div>
                <p>{renderText(item.description)}</p>
              </div>
            ))}
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default TestimonialsList;
